import { leaseCol } from "../app/modules/BookingformList/leaseColumn";
import { columnDefs } from "../app/modules/Contracts/PostDatedCheques/pdcColumn";
import { defaultColumns } from "../app/modules/Units/grid/columns";
import { gridSettings, saveGidSettings } from "../configs/constants";
import axios from "./axiosInceptor";

const getScreenColumn = (screenName) => {
  if (screenName === "payment") {
    return columnDefs;
  } else if (screenName === "units") {
    return defaultColumns;
  }
};

export const saveGridSettings = async (screenName, gridSettings = null, directPost = false) => {
  try {
    if (!screenName && !gridSettings && !directPost) return false;
    let payload = { screen: screenName };

    payload["settings"] = gridSettings;
    let response = await axios.post(`${saveGidSettings}`, payload);

    return response?.data?.result ? response?.data?.result?.settings : [];
  } catch (error) {
    console.log(error);
  }
};

export const getGridSettings = async (screenName, column = null, directPost = false) => {
  try {
    const gridConfig = await axios.get(`${gridSettings}${screenName}`);

    if (!gridConfig?.data?.result) {
      let data = await saveGridSettings(screenName, column, true);
      return data;
    } else if (screenName && column && directPost) {
      let data = await saveGridSettings(screenName, column, directPost);
      return data;
    } else if (!directPost) {
      return gridConfig?.data?.result?.settings;
    }
  } catch (erro) {
    console.log(erro);
  }
};
